/**
 * Constants for `App`.
 *
 * @module @app/constants
 */

export const BOOT_SPLASH_ENABLED = true;

export const BOOT_SPLASH_DURATION_MS = 2000;

// Safety cap for the cold-load profile gate: if the profile API is slow/down, lift the boot
// overlay anyway (render with token-only identity) rather than freezing startup.
export const PROFILE_GATE_TIMEOUT_MS = 5000;
